import React, { useState } from 'react';
import DisplayField, { FieldColor } from './DisplayField';
import { ShopifyStatus } from '../../services/catalog/types';
import { Button, CircularProgress, Grid } from '@material-ui/core';
import { createShopifyFullExport } from '../../services/catalog/services';
import { Alert } from '@mui/material';
import { handleApiError } from '../../pages/catalog/utils';

interface Props {
  status?: ShopifyStatus;
  productId?: number;
}

const ShopifyStatusField: React.FC<Props> = ({ status, productId }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string | null>(null);
  const [error, setError] = useState<string | string[] | undefined>();
  if (!status) {
    return null;
  }

  const handleCreateProduct = async () => {
    try {
      setLoading(true);
      await createShopifyFullExport(Number(productId));
      setResult('Product queued for creation in Shopify');
    } catch (err) {
      handleApiError(err, setError);
    } finally {
      setLoading(false);
    }
  };

  let color: FieldColor;
  if (status === ShopifyStatus.Active) {
    color = 'success';
  } else if (status === ShopifyStatus.Draft) {
    color = 'warning';
  } else if (status === ShopifyStatus.Archived) {
    color = 'danger';
  } else {
    color = 'neutral';
  }

  const showCreateButton = status === ShopifyStatus.NotInShopify && productId;

  return (
    <>
      <DisplayField label="Shopify Status" value={status} color={color} />
      {showCreateButton && (
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Button
              variant="contained"
              onClick={handleCreateProduct}
              disabled={loading}
              endIcon={loading && <CircularProgress size={16} />}
            >
              Create Product in Shopify
            </Button>
          </Grid>
          <Grid item xs={2}>
            {result && <Alert severity="success">{result}</Alert>}
            {error && <Alert severity="error">{error}</Alert>}
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ShopifyStatusField;
